import React from 'react';
import { useMessageSource } from 'react-message-source';
import './style.scss';

import Tooltip from '@uiParts/tooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faClipboardCheck } from '@fortawesome/pro-regular-svg-icons';
import { useCopyButton } from './hooks';

type CopyButtonProps = {
  copiedText: string;
  className?: string;
  title?: string;
  disabled?: boolean;
};

const CopyButton = (props: CopyButtonProps) => {
  const { getMessage } = useMessageSource();
  const { copied, handleCopy, handleMouseLeave } = useCopyButton();

  return (
    <div
      className={'copy-button-wrapper' + (copied ? ' copied' : '')}
      onMouseLeave={handleMouseLeave}
    >
      <Tooltip
        tooltipText={copied ? getMessage('ui.copyButton.0002') : getMessage('ui.copyButton.0001')}
      >
        <button
          className={`copy-button ${props.className ?? ''}`}
          type="button"
          title={props.title}
          disabled={props.disabled}
          onClick={() => handleCopy(props.copiedText)}
        >
          <FontAwesomeIcon icon={copied ? faClipboardCheck : faClipboardList} />
        </button>
      </Tooltip>
    </div>
  );
};

export default CopyButton;
